import React, { FC } from 'react';

import useStyles from './styles';
import EllipsisTooltip from '../EllipsisTooltip';
import cx from 'classnames';
import { resolveTicketStatusGroup } from '../../utils/resolveTicketStatusGroup';
import { ITypographyProps } from '../EllipsisTooltip/EllipsisTooltip';

interface IProps {
  text: string;
  typographyProps?: ITypographyProps;
  status: string;
  className?: string;
}

const StatusChip: FC<IProps> = ({ text, status, className, typographyProps }) => {
  const classes = useStyles();

  return (
    <EllipsisTooltip
      text={text}
      typographyProps={{
        className: cx(classes.chipStatus, className, classes[resolveTicketStatusGroup(status)]),
        isDarkTextColor: false,
        fontSize: '12px',
        ...typographyProps
      }}
    />
  );
};

export default StatusChip;
